<template>
  <span class="flex">
    <p class="before" v-if="text && showText && iconAfter">{{ text }}</p>
    <span class="icon">
      <i :class="icon"></i>
    </span>
    <p class="after" v-if="text && showText && !iconAfter">{{ text }}</p>
  </span>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    iconAfter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  background-color: transparent;
  text-align: center;

  p {
    display: inline;
    &.before {
      // Si le texte est avant
      margin-right: 5px;
    }
    &.after {
      // Si le texte est après
      margin-left: 5px;
    }
  }
}
</style>
